import React, { useCallback, useEffect, useState } from "react";
import "./chathistorytable.scss";
import NodataFound from "../../../../assets/images/no-data-vector.svg";
import { useSelector } from "react-redux";
import moment from "moment";
import Pagination from "../../../../components/pagination/index";
import Input from "../../../../components/input";
import useDebounce from "../../../../common/Hooks/useDebounce";

export default function Chathistorytable({
  handleOnClickChat,
  totalData,
  itemsPerPage,
  currentPage,
  handleApiCall,
  filterCategory,
  setCurrentPage,
}) {
  const { userChat, selectedProject } = useSelector((state) => state.project);
  const [searchValue, setSearchValue] = useState("");
  const debounce = useDebounce(searchValue, 1000);
  const debouncedHandleApiCall = useCallback(
    (page, limit, search) => {
      handleApiCall(page, limit, search);
    },
    [handleApiCall]
  );

  useEffect(() => {
    debouncedHandleApiCall(1, 10, debounce);
  }, [debounce, debouncedHandleApiCall]);

  // Determine dynamic columns
  let columns = [];
  const config = selectedProject?.form_config;
  if (Array.isArray(config) && config.length > 0) {
    columns = config.map(f => ({
      label: f.label,
      key: f.name || f.label?.toLowerCase().replace(/[^a-z0-9]/g, '_')
    }));
  } else {
    // Default Columns (Legacy)
    columns = [
      { label: "Name", key: "name" },
      { label: "Phone No.", key: "phone" },
      { label: "Email", key: "email" },
      { label: "Course Interested", key: "course_interested" }
    ];
  }

  return (
    <>
      <div className="chat-history-table-alignment">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            margin: "0 0 25px 0",
          }}
        >
          <h4>Chat History</h4>
          <Input
            name={"name"}
            placeholder="Search..."
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </div>
        <div className="table-design" style={{ overflowX: 'auto' }}>
          <table>
            <thead>
              <tr>
                {columns.map((col, idx) => (
                  <th key={idx}>{col.label}</th>
                ))}
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {userChat?.length > 0 ? (
                userChat?.map((item) => {
                  var date = new Date(`${item?.created_at} UTC`);
                  const createdOn = date.toString();
                  const formData = item.form_data || {};

                  return (
                    <tr onClick={() => handleOnClickChat(item)} key={item.id}>
                      {columns.map((col, idx) => {
                        const val = formData[col.key] || item[col.key] || "-";
                        return (
                          <td key={idx}>
                            {col.key === 'name' ? (
                              <div className="image-text">
                                <span>{val}</span>
                              </div>
                            ) : (
                              <span>{val}</span>
                            )}
                          </td>
                        );
                      })}
                      <td>
                        <span>{moment(createdOn).format("lll")}</span>
                      </td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan={columns.length + 1}>
                    <div className="new-data-not-found-alignment">
                      <div className="image-center-alignment">
                        <img src={NodataFound} alt="NodataFound" />
                      </div>
                      <h4>No Chat History</h4>
                      <p>
                        No chat records found yet.
                      </p>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className="pagination-top-alignment">
        <Pagination
          totalData={totalData}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          handleApiCall={handleApiCall}
          filterCategory={filterCategory}
          setCurrentPage={setCurrentPage}
        />
      </div>
    </>
  );
}
